import React, { useMemo, useCallback } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import IfPermitted from "components/common/IfPermitted";
import { LinkContainer } from "components/common";
import { DropdownButton, MenuItem } from "components/bootstrap";
import { SIGMA_ENTITY_CREATORS } from "./index";
const PermissionWrapper = ({
  permissions = void 0,
  children = void 0
}) => permissions ? /* @__PURE__ */ React.createElement(IfPermitted, { permissions }, children) : /* @__PURE__ */ React.createElement(React.Fragment, null, children);
const useEntityCreators = (entityKeys) => {
  const entityCreators = usePluginEntities("entityCreators");
  return useMemo(
    () => entityCreators.filter((creator) => entityKeys.includes(creator.id)),
    [entityCreators, entityKeys]
  );
};
function SigmaEventDefinitionsOptions({ disabled = false }) {
  const entityCreators = useEntityCreators(Object.values(SIGMA_ENTITY_CREATORS));
  const sendTelemetry = useSendTelemetry();
  const _menuItemOnClick = useCallback(
    (creator) => () => {
      const { telemetryEvent } = creator;
      if (telemetryEvent) {
        sendTelemetry(telemetryEvent.type, {
          app_section: telemetryEvent.section,
          app_action_value: telemetryEvent.actionValue
        });
      }
    },
    [sendTelemetry]
  );
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      bsSize: "md",
      bsStyle: "primary",
      title: "",
      pullRight: true,
      id: "sigma-entity-creators-dropdown",
      disabled: disabled || entityCreators.length === 0
    },
    entityCreators.map((creator) => /* @__PURE__ */ React.createElement(PermissionWrapper, { key: creator.id, permissions: creator.permissions }, /* @__PURE__ */ React.createElement(LinkContainer, { to: creator.path }, /* @__PURE__ */ React.createElement(MenuItem, { onClick: _menuItemOnClick(creator) }, creator.title))))
  );
}
export default SigmaEventDefinitionsOptions;
